module.exports = __webpack_public_path__ + "static/media/mall-discount.c5c4049b.svg";